import { render, staticRenderFns } from "./UpdateCustomerSourcePopup.vue?vue&type=template&id=3cdf4a54&scoped=true&"
import script from "./UpdateCustomerSourcePopup.vue?vue&type=script&lang=js&"
export * from "./UpdateCustomerSourcePopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cdf4a54",
  null
  
)

export default component.exports